import React, { useState } from 'react';
import './FeedbackModal.css';
import { CloseIcon } from '../components/Icons';

interface FeedbackModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (feedback: string) => void;
  onSkip: () => void;
}

const FeedbackModal: React.FC<FeedbackModalProps> = ({
  isOpen,
  onClose,
  onSubmit,
  onSkip,
}) => {
  const [feedback, setFeedback] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  if (!isOpen) return null;

  const handleSubmit = async () => {
    setIsSubmitting(true);
    await onSubmit(feedback);
    setIsSubmitting(false);
    setFeedback('');
  };

  const handleSkip = () => {
    setFeedback('');
    onSkip();
  };

  const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="feedback-modal-overlay" onClick={handleOverlayClick}>
      <div className="feedback-modal">
        {/* Close button */}
        <button className="feedback-modal-close" onClick={onClose}>
          <CloseIcon/>
        </button>

        {/* Header */}
        <div className="feedback-modal-header">
          <h2 className="feedback-modal-title">Share Your Feedback</h2>
          <p className="feedback-modal-subtitle">
            Help us improve! Share your thoughts, suggestions, or any feedback about your experience.
          </p>
        </div>

        {/* Textarea */}
        <div className="feedback-modal-body">
          <textarea
            className="feedback-modal-textarea"
            placeholder="What did you like? What could be better? Any suggestions..."
            value={feedback}
            onChange={(e) => setFeedback(e.target.value)}
            rows={5}
          />
        </div>

        {/* Actions */}
        <div className="feedback-modal-actions">
          <button
            className="feedback-modal-button feedback-modal-button--submit"
            onClick={handleSubmit}
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Submitting...' : 'Submit & Download'}
          </button>
          <button
            className="feedback-modal-button feedback-modal-button--skip"
            onClick={handleSkip}
            disabled={isSubmitting}
          >
            Skip & Download
          </button>
        </div>
      </div>
    </div>
  );
};

export default FeedbackModal;